import { Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { default as React } from "react";
import { ReportDataField } from "../../../../../../models/Reporting/ReportDataField";
import {
    FieldUse,
    ReportField,
} from "../../../../../../models/Reporting/ReportField";
import { useStore } from "../../../../../../utils/useStore";
import { ReportEditorStore } from "../../../Stores/ReportEditorStore";
import { QuickFilterOptions } from "../Editor";
import ReportFieldTransferList from "./ReportFieldTransferList";

function quickFilterFieldNameSelector(
    reportDataField: ReportDataField | ReportField,
) {
    if (reportDataField instanceof ReportField) {
        return reportDataField.reportDataField!.displayName;
    } else {
        return reportDataField.displayName;
    }
}

function quickFilterPredicate(field: ReportField) {
    return field.fieldUse === FieldUse.QuickFilter;
}

interface OwnProps {}

type Props = OwnProps;

const QuickFilterSection: React.FC<Props> = observer((props: Props) => {
    const store = useStore(ReportEditorStore);

    return (
        <>
            <Grid
                container
                item
                xl={7}
                lg={7}
                md={7}
                sm={7}
                xs={7}
                direction="row"
                wrap={"nowrap"}
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{ paddingTop: "17px" }}
            >
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={12}>
                        {store.quickFilterOption ===
                            QuickFilterOptions.Custom && (
                            <>
                                {" "}
                                <Typography
                                    sx={{
                                        fontFamily: "Inter",
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        letterSpacing: "0",
                                        lineHeight: "28px",
                                    }}
                                >
                                    Quick Filters
                                </Typography>
                                <Typography variant="caption">
                                    Quick filters appear on the report to allow
                                    additional filtering on-the-fly.
                                </Typography>
                            </>
                        )}
                    </Grid>

                    <ReportFieldTransferList
                        onSelectedFields={
                            store.currentReport?.changeQuickFilters
                        }
                        hideAggregateSelectors
                        reportFieldPredicate={quickFilterPredicate}
                        labelFieldSelector={quickFilterFieldNameSelector}
                        availableFields={store.availableReportQuickFilterFields}
                        selectedFields={
                            store.currentReport?.quickFilterReportDataFields ??
                            []
                        }
                        selectedFieldsTitle={"Selected Filters"}
                        availableFieldsTitle={"Available Filters"}
                        idField={"displayName"}
                        height={"350px"}
                    />
                </Grid>
            </Grid>
        </>
    );
});

export default QuickFilterSection;
